

import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import CustomisedButton from "../../components/button/button";
import SimpleCard from "../../components/card/simpleCard/simpleCard";
import EmptyStyle from "../../components/emptyStyles/emptyStyle";
import ConfirmDeleteModal from "../../components/modal/confirmDeleteModal";
import ElementTitle from "../../components/title/elementTitle/elementTitle";
import { SALE_ID, UUID } from "../../config/cacheKey";
import { ICancelInvoiceByCustomerRequest, IGetSaleInfoResponse, IGetWaitForCustomerApproveSalesResponse } from "../../models/sale.model";
import { changeRouteType, getpervInnerState } from "../../redux/handleBackBtn/handleBackBtnSlice";
import { setHeaderTitle } from "../../redux/headerTitle/headerTitleSlice";
import { setUnAuthorizedState } from "../../redux/unAuthorizedState/unAuthorizedStateSlice";
import { getJwtToken, getTokenTime } from "../../services/auth.service";
import { CancelInvoiceByCustomer, GetSaleInfo, GetWaitForCustomerApproveSales } from "../../services/sale.service";
import { IOngoingDetailPurchase } from "./IOngoingDetailPurchase";
import OngoingDetailPurchaseSkeleton from "./ongoingDetailPurchaseSkeleton";
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import EmptyLoanStyle from "../../components/icons/EmptyLoanStyle";


export default function OngoingDetailPurchase({ ongoingPurchases, setWaitingSales, setState }: IOngoingDetailPurchase) {
    const [data, setData] = useState<IGetSaleInfoResponse>();
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const queryClient = useQueryClient();
    const saleKey: string = queryClient.getQueryData(SALE_ID)!;
    const { token, refToken } = getJwtToken();



    const randomKeyForDispatch = Math.random();
    const dispatch = useDispatch();


    const { mutateAsync, isLoading } = useMutation(GetSaleInfo, {
        onSuccess: (data) => {
            setData(data)
        }
    });


    const getWaitForCustomerApproveSalesMutate = useMutation(GetWaitForCustomerApproveSales, {
        onSuccess: (data: IGetWaitForCustomerApproveSalesResponse[]) => {

            if (data != null && data.length > 0) {
                setState('ongoingPurchases')
            } else {
                setState('home')
            }
            setWaitingSales && setWaitingSales(data)
        }
    });


    const cancelInvoiceByCustomerMutate = useMutation(CancelInvoiceByCustomer, {
        onSuccess: (data: boolean) => {

            if (data) {
                getWaitForCustomerApproveSalesMutate.mutate();
                queryClient.removeQueries(SALE_ID);
            } else {
                setOpenVerifyModal(false);
                setConfirm(false);
            }
        }
    });

    useEffect(() => {
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'جزییات خرید', parentRoute: 'home' }));
        dispatch(changeRouteType({ routeType: 'child' }));
        if (ongoingPurchases != 1) {
            dispatch(getpervInnerState({ prevInnerState: `ongoingPurchases ${randomKeyForDispatch}` }));
        } else {
            dispatch(getpervInnerState({ prevInnerState: `home ${randomKeyForDispatch}` }));
        }


        mutateAsync(saleKey);
    }, []);





    useEffect(() => {
        if (confirm === true) {
            getTokenTime();
            const { token, refToken } = getJwtToken();
            if (token) {

                cancelInvoiceByCustomerMutate.mutate({ saleKey: saleKey } as ICancelInvoiceByCustomerRequest)

            } else {
                // navigate('/login')
                dispatch(setUnAuthorizedState({ state: `login ${UUID}` }))
            }
        }
    }, [confirm])
    const deletePurchase = () => {
        setOpenVerifyModal(true);
    }


    const handleUpdate = () => {
        mutateAsync(saleKey);
    }

    const handleLogin = () => {
        dispatch(setUnAuthorizedState({ state: `login ${UUID}` }))
    }

    // useEffect(() => {
    //     dispatch(setHeaderTitle({ color: '#fff', header: msg, parentRoute: 'guarantors' }));
    //     dispatch(changeRouteType({ routeType: 'child' }));
    //     dispatch(getpervInnerState({ prevInnerState: `guarantors ${randomKeyForDispatch}` }));

    // }, []);

    if (isLoading) {
        return <OngoingDetailPurchaseSkeleton />;
    }

    if (!data) {
        return <>
            <Box sx={{ height: "90svh", display: "flex", justifyContent: "center", alignItems: "center" }}  >
                <EmptyStyle icon={<EmptyLoanStyle className="className='text-[var(--primary-text-color)]'" />} text={'خرید در جریانی یافت نشد.'} emphasisedWords={['در جریانی']} emphasisedWordsColor={'#BBA57A'} />

            </Box>
        </>
    }

    return (
        <>
            <div className='p-5 flex flex-col items-center justify-between h-[calc(100svh-120px)]'
            // style={{ height: token ? 'calc(100svh - 120px)' : 'calc(100svh - 60px)', overflowY: 'scroll' }}
            >
                <div className="w-full overflowYScroll" style={{ maxHeight: token ? 'calc(100svh - 250px)' : 'calc(100svh - 190px)', overflowY: 'scroll' }}>

                    <span className="font-normal text-sm primaryColorLight-900 anjomanRegular" style={{ fontSize: '14px', marginInline: "20px", display: "block" }}>لطفا درصـورتی که جزییات و مبالغ خرید مورد تاییـد شـما میبـاشد، <span style={{ color: "#BBA57A", fontWeight: "bold" }}>کد تایید</span> زیر را در اختیار فروشنده قرار دهید. توجه داشته باشید با تحـویل کد به فروشنـده، خرید نهـایی شده و مبـلغ <span style={{ color: "#FF617C", fontWeight: "bold" }}> {data?.totalAmount.toLocaleString()} ریال </span>  از اعتبار شما <span style={{ color: "#FF617C", fontWeight: "bold" }}>کسر</span> خواهد شد.</span>

                    {data?.otp &&
                        <>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: "10px", width: '100%' }}>
                                {data?.otp.split('').map((digit, index) => (
                                    <Box key={index} sx={{ display: "flex", justifyContent: "center", alignItems: "center", border: '1px solid #D7DBEC', padding: '10px', borderRadius: '5px', flex: 1, textAlign: 'center', backgroundColor: "#fff", aspectRatio: '1' }}>
                                        <Typography sx={{ fontSize: "2rem !important", fontWeight: "bold" }}>
                                            {digit}
                                        </Typography>
                                    </Box>
                                )).reverse()}
                            </div>    </>}
                    <Typography sx={{ color: "#BBA57A", fontSize: ".785rem", textAlign: "end", marginTop: "5px" }} onClick={handleUpdate}>
                        <ReplayOutlinedIcon sx={{ fontSize: "1rem", transform: "scaleX(-1)", rotate: "45deg", marginLeft: "5px" }} />
                        بروزرسانی
                    </Typography>
                    <div className="mt-5">
                        <ElementTitle title="جزییات خرید" />
                    </div>
                    <SimpleCard>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontSize: ".85rem", paddingRight: "5px" }}> <img style={{ width: "40px", height: "40px", display: "inline-block" }} src={`data:image/png;base64,${data?.storeLogoBase64}`} />&nbsp; {data?.storeTitle}</span>
                                {/* src={`data:image/png;base64,${data?.storeLogoBase64}`} */}
                            </div>

                        </div>
                        <hr className="sale-item-hr" />

                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", paddingBottom: "10px", fontSize: '.85rem', paddingRight: "5px", gap: "5px" }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontSize: ".9rem", fontWeight: "normal" }}> {data?.branchTitle} </span>
                            </div>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontSize: "0.9rem", color: "var(--primary-text-color)" }}> {data?.branchAddress} </span>
                            </div>

                        </div>

                    </SimpleCard>

                    <SimpleCard>


                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontWeight: "normal", paddingRight: "5px", fontSize: '.85rem' }}>تاریخ انقضا</span>
                            </div>
                            <div style={{ alignContent: "flex-end" }}>
                                <span style={{ color: "#FF617C", fontSize: '.85rem', fontWeight: "bold" }}>  {data?.expirationDatePersian} </span>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontWeight: "normal", paddingRight: "5px", fontSize: '.85rem' }}>مبلغ اعتبار</span>
                            </div>
                            <div style={{ alignContent: "flex-end" }}>
                                <span style={{ color: "var(--primary-text-color)", fontSize: '.85rem' }}> {data?.creditAmount.toLocaleString()} ریال</span>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontWeight: "normal", paddingRight: "5px", fontSize: '.85rem' }}>مبلغ نقدی</span>
                            </div>
                            <div style={{ alignContent: "flex-end" }}>
                                <span style={{ color: "var(--primary-text-color)", fontSize: '.85rem' }}>  {data?.cashAmount.toLocaleString()} ریال</span>
                            </div>
                        </div>
                        {data?.cashAmount > 0 && <span style={{ color: "#FB8C00", fontSize: '.7rem', marginBottom: "10px" }}> توجه داشته باشید این مبلغ توسط فروشنده به صورت نقـدی از شما دریافت خواهد شد.</span>}
                        <hr className="sale-item-hr" />
                        <div className="my-2" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px", fontSize: '.9rem !important' }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontWeight: "normal", paddingRight: "5px" }}>جمع کل فاکتور</span>
                            </div>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ paddingRight: "5px", fontSize: "1rem" }}> <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>{data?.totalAmount.toLocaleString()}</span> ریال</span>
                                {/* {data.totalAmount?.toLocaleString()} */}
                            </div>
                        </div>
                    </SimpleCard>

                    {(data?.items && data?.items.length > 0) ?
                        <SimpleCard>
                            {data?.items?.map((item, index) => (
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", paddingBottom: "10px", fontSize: '.85rem' }}>
                                    <div style={{ alignContent: "flex-start" }}>
                                        <span style={{ fontSize: ".9rem", fontWeight: "normal", paddingRight: "5px" }}>{item.title} <span style={{ color: '#BBA57A', fontSize: '0.8rem', fontWeight: "bold" }}>({item.quantity} {item.unitType})</span> </span>
                                    </div>
                                    <div style={{ textAlign: "left" }}>
                                        <span style={{ fontSize: "0.9rem", color: "var(--primary-text-color)" }}> {Number(item?.totalAmount).toLocaleString('fa')} ریال  </span>
                                    </div>{index !== data.items.length - 1 && (<hr className="sale-item-hr" />)}

                                </div>
                            ))}
                        </SimpleCard> : <></>
                    }
                </div>

                <div className="w-full ">

                    {token ? <div className="py-5">
                        <CustomisedButton
                            title={'ابطال خرید'}
                            disable={false}
                            onClick={deletePurchase}
                            type="submit"
                            specializedColor={"#FF617C !important"}
                        />
                    </div> :
                        <div className="py-5">
                            <CustomisedButton
                                title={'ورود به حساب کاربری'}
                                disable={false}
                                onClick={handleLogin}
                                type="submit"
                                specializedColor={"#BBA57A !important"}
                            />
                        </div>
                    }
                </div>
            </div >
            <ConfirmDeleteModal text={"آیا از ابطال این خرید اطمینان داید؟"}
                buttonTitle={'بله'}
                delButton={true}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
                deleteTitle={"خیر"}

            />
        </>
    )
}